import blobSettings from './blobSettings.json';

export const defaultSettings = blobSettings;
  